import servicesUtils from "../../../utils/servicesUtils";
var getEmrRecords = function getEmrRecords(workspaceId, patientId) {
  return servicesUtils.getService("/emr/workspaces/".concat(workspaceId, "/patients/").concat(patientId, "/"));
};
export default getEmrRecords;